export function getFirstName(fullName: string | null | undefined): string {
  if (!fullName?.trim()) return '';
  return fullName.trim().split(/\s+/)[0];
}

/**
 * Splits a full name into `{ firstName, lastName }`.
 * Everything before the first space is `firstName`; everything after is `lastName`.
 * Returns `null` for both when the input is empty or null.
 */
export function splitName(fullName: string | null | undefined): {
  firstName: string | null;
  lastName: string | null;
} {
  if (!fullName?.trim()) return { firstName: null, lastName: null };
  const idx = fullName.indexOf(' ');
  if (idx === -1) return { firstName: fullName, lastName: null };
  return { firstName: fullName.substring(0, idx), lastName: fullName.substring(idx + 1) };
}
